import { render, staticRenderFns } from "./TextStyleDefinition.vue?vue&type=template&id=a0d850cc&scoped=true"
import script from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
export * from "./TextStyleDefinition.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TextStyleDefinition.vue?vue&type=style&index=0&id=a0d850cc&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a0d850cc",
  null
  ,true
)

export default component.exports